import { getDateFnsLocale } from '@advanza/func'
import rdpStyle from '@advanza/input/reactDayPickerStyle.module.css'
import { Button, Divider } from '@advanza/ui'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import BaseModal, {
    BaseModalHeader,
    BaseModalMainContent,
} from '@trustoo/components/modal/BaseModal'
import { subDays } from 'date-fns'
import { DayPicker } from 'react-day-picker'

interface Props {
    modalTitle?: string
    date?: Date
    defaultMonth?: Date
    /** Offer a reset action next to the calendar, which resolves with `null`. */
    deselectable?: boolean
}

/**
 * Picks a single day, no earlier than today. Resolves with the picked `Date`, with `null` when the
 * current selection is reset, and with `undefined` when closed without picking.
 */
const DateInputModal = NiceModal.create(
    ({ modalTitle, date, defaultMonth, deselectable }: Props) => {
        const modal = useModal()

        const resolveWith = (picked: Date | null) => {
            modal.resolve(picked)
            modal.hide()
        }

        return (
            <BaseModal mobileFullscreen maxWidth={400}>
                {modalTitle && (
                    <BaseModalHeader>
                        <h2 className="text-xl font-bold">{modalTitle}</h2>
                    </BaseModalHeader>
                )}
                <BaseModalMainContent>
                    <Divider ml />
                    <div className="rounded-[5px] border border-solid border-[#dbdce0] bg-white p-4">
                        <DayPicker
                            locale={getDateFnsLocale()}
                            disabled={(day) => day <= subDays(new Date(), 1)}
                            fromMonth={new Date()}
                            defaultMonth={defaultMonth}
                            selected={date}
                            onDayClick={(selectedDate) => resolveWith(selectedDate)}
                            classNames={rdpStyle}
                            footer={
                                deselectable ? (
                                    <>
                                        <Divider s />
                                        <Button name="text2" onClick={() => resolveWith(null)}>
                                            Reset selected day
                                        </Button>
                                    </>
                                ) : undefined
                            }
                        />
                    </div>
                    <Divider ml />
                </BaseModalMainContent>
            </BaseModal>
        )
    },
)

export default DateInputModal
